const Component15 = ({ items, handleSelection, selectedCategory, selectedColor }) => {
  if (items.length !== 15) {
    return <div>Questo componente è progettato per 15 elementi!</div>;
  }

  const isOutOfStock = (item) => {
    const v = item?.out_of_stock;
    return v === 1 || v === true || v === "1" || v === "true";
  };

  const isNoneItem = (item) => item?.id === "none";

  const firstColumnItems = items.slice(0, 3);
  const secondColumnItem = items.slice(3, 6);
  const terzaColumnItem = items.slice(6, 9);
  const quartaColumnItem = items.slice(9, 12);
  const quintaColumnItem = items.slice(12, 15);

  const getItemClass = (itemId, item) => {
    const selected = selectedColor === itemId ? "selected-border" : "";
    const disabled = isOutOfStock(item) ? "disabled" : "";
    const noneCls = isNoneItem(item) ? "grid-item-none" : "";
    return `${selected} ${disabled} ${noneCls}`.trim();
  };

  const getItemStyle = (item) => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "4px",
    height: "50%",
    color: "white",
    backgroundImage: `url("${item.bg}")`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundSize: item?.id === "none" ? "60% auto" : "cover",
  });

  const columns = [
    firstColumnItems,
    secondColumnItem,
    terzaColumnItem,
    quartaColumnItem,
    quintaColumnItem,
  ];

  return (
    <div
      className="row m-0"
      style={{
        gap: "10px",
        width: "100%",
        height: "100%",
      }}
    >
      {columns.map((columnItems, colIndex) => (
        <div key={`col-${colIndex}`} className="col p-0 d-flex flex-column" style={{ gap: "10px" }}>
          {columnItems.map((item, index) => (
            <div
              key={`col-${colIndex}-row-${index}`}
              onClick={() => {
                if (isOutOfStock(item)) return;
                handleSelection(selectedCategory, item.id);
              }}
              className={`grid-item ${getItemClass(item.id, item)}`}
              style={getItemStyle(item)}
            ></div>
          ))}
        </div>
      ))}
    </div>
  );
};

export default Component15;
